export class TimeOutError extends Error {
    constructor(message?: string) {
        super(message);

        // Set the prototype explicitly.
        Object.setPrototypeOf(this, TimeOutError.prototype);
    }
}
